import React from 'react';
import { useTranslation } from 'react-i18next';
import './not.found.scss';

export default function ProposalNotFound() {
  const { t } = useTranslation();
  return <div data-testid="no-event" className="no-event">
    <div className="error-message">{t('event.errors.notFound')}</div>
  </div>;
}